import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss']
})
export class AutoCompleteComponent implements OnInit {
  search: any;
  showList: boolean;
  options: any[] = [];
  @Input() searchField: string;
  @Input() showField: string;
  @Input() disabled = false;
  @Input() clearAfterSearch = false;
  @Input() data: any[];
  @Output() onItemSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() placeholder?: string;
  constructor() {
  }

  ngOnInit() {
    if (!this.searchField || !this.showField) {
    }
  }
  onSearchChange() {
    if (!this.data) {
    } else {
      this.options = [];
      if (this.search && this.search.trim() !== '') {
        this.data.forEach(element => {
          if (element[this.searchField].toLowerCase().includes(this.search.toLowerCase())) {
            this.options.push(element);
          }
        });
      }
      this.focusIn();
    }
  }
  selected(item) {
    this.search = item[this.showField];
    this.onItemSelected.emit(item);
  }
  /**
   * @name focusOut
   * @description Al salir del focus del input
   */
  focusOut() {
    setTimeout(() => {
      this.showList = false;
    }, 300);
  }
  /**
   * @name
   * @description AL hacer focus la input
   */
  focusIn() {
    this.showList = this.options.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/auto-complete/auto-complete.component.ts